import { jsx as n } from "react/jsx-runtime";
import { cn as s } from "@tameeni/shared-logic";
import { useMemo as l, Suspense as f } from "react";
import t, { ImageKeys as m } from "../svgs/index.js";
import u from "./lazy-image.js";
function z({ name: o, className: r, ...i }) {
  const e = l(
    () => t[o],
    [o]
  );
  if (!e)
    return console.warn(`Icon "${o}" not found`), null;
  const c = /* @__PURE__ */ n(
    "div",
    {
      className: s(
        "animate-pulse rounded bg-slate-200/50 size-4.5",
        r
      )
    }
  );
  return m.includes(o) ? /* @__PURE__ */ n(
    u,
    {
      src: t[o],
      className: s("shrink-0 size-4.5", r),
      alt: o
    }
  ) : /* @__PURE__ */ n(f, { fallback: c, children: /* @__PURE__ */ n(
    e,
    {
      className: s("shrink-0 size-4.5", r),
      ...i
    }
  ) });
}
export {
  z as Icon
};
//# sourceMappingURL=icon.js.map
